/**
 * 背幅計算ページ専用JavaScript
 * 元サイト: https://www.maruiro.com/page/SpineWidthCalculator/
 * 
 * このスクリプトは背幅計算ページでのみ読み込まれます
 */

// 用紙の厚みデータベース
function PaperList() {
    this.cover = {
        '用紙を選択してください': '選択してください',
        'コート90kg': 0.080,
        'コート110kg': 0.100,
        'コート135kg': 0.120,
        'マット110kg': 0.130,
        'マット135kg': 0.165,
        'マット180kg': 0.230,
        'マット220kg': 0.300,
        '上質110kg': 0.154,
        '上質135kg': 0.188,
        '上質180kg': 0.250,
        'アートポスト180kg': 0.200,
        'アートポスト220kg': 0.270
    };
    
    this.paper = {
        '用紙を選択してください': '選択してください',
        'コート73kg': 0.070,
        'コート90kg': 0.080,
        'コート110kg': 0.100,
        'マット70kg': 0.080,
        'マット90kg': 0.105,
        'マット110kg': 0.130,
        '上質70kg': 0.100,
        '上質90kg': 0.124,
        '上質110kg': 0.154
    };
}

// 全角数字を半角に変換
function toHankakuNum(motoText) {
    var han = "0123456789";
    var zen = "０１２３４５６７８９";
    var str = "";
    for (var i = 0; i < motoText.length; i++) {
        var c = motoText.charAt(i);
        var n = zen.indexOf(c, 0);
        if (n >= 0) c = han.charAt(n);
        str += c;
    }
    return str;
}

// 数字以外を除去（半角変換）
function replaceNum(txt) {
    txt.value = toHankakuNum(txt.value);
    txt.value = txt.value.replace(/\D/g, "");
}

// 背幅計算のメイン処理
function se_check() {
    var plt = new PaperList();

    // .spine-calculator 内のフォーム要素を取得（page.content の古いフォームを避ける）
    var container = document.querySelector('.spine-calculator');
    if (!container) {
        console.error('[Spine Calculator] Container .spine-calculator not found');
        alert('計算フォームが見つかりません。ページを再読み込みしてください。');
        return false;
    }

    // 結果表示要素も .spine-calculator 内から取得
    var resultTag = container.querySelector('#sw_calculation_result');
    if (!resultTag) {
        console.error('[Spine Calculator] Result element not found in container');
        return false;
    }

    var coverSelect = container.querySelector('#cover_select');
    var paperSelect = container.querySelector('#paper_select');
    var pageInput = container.querySelector('#page');

    if (!coverSelect || !paperSelect || !pageInput) {
        console.error('[Spine Calculator] Form elements not found in container', { coverSelect, paperSelect, pageInput });
        alert('フォーム要素が見つかりません。ページを再読み込みしてください。');
        return false;
    }

    var csel = coverSelect.value; // 表紙用紙選択
    var psel = paperSelect.value; // 本文用紙選択
    var page = pageInput.value; // 本文ページ数

    // デバッグログ
    console.log('[Spine Calculator] Values:', { csel, psel, page });
    console.log('[Spine Calculator] Paper lookup:', { key: psel, value: plt.paper[psel] });
    console.log('[Spine Calculator] Cover lookup:', { key: csel, value: plt.cover[csel] });

    // 本文用紙の選択チェック（未選択または存在しない用紙の場合）
    if (!psel || psel === '用紙を選択してください' || plt.paper[psel] === undefined || plt.paper[psel] === '選択してください') {
        alert("本文に使用する用紙を選択してください。");
        return false;
    }

    // 表紙用紙の選択チェック（未選択または存在しない用紙の場合）
    if (!csel || csel === '用紙を選択してください' || plt.cover[csel] === undefined || plt.cover[csel] === '選択してください') {
        alert("表紙に使用する用紙を選択してください。");
        return false;
    }
    
    // ページ数の検証
    if (page == "") {
        alert('本文のページ数を入力してください。');
        return false;
    } else {
        if (page == 0) {
            alert('本文のページ数は、0以外を入力してください。');
            return false;
        } else if (isFinite(page) == false) {
            alert('本文のページ数は、数値で入力してください。');
            return false;
        }
    }
    
    // 背幅計算
    var paperThickness = plt.paper[psel];
    var coverThickness = plt.cover[csel];

    if (page && paperThickness && coverThickness && typeof paperThickness === 'number' && typeof coverThickness === 'number') {
        // 計算式: (ページ数 / 2 × 本文用紙の厚み) + (表紙用紙の厚み × 2)
        var kai = (parseFloat(page) / 2 * paperThickness) + (coverThickness * 2);
        var result = Math.ceil(kai);
        resultTag.innerHTML = '<span class="result-label">背幅</span><span class="result-value">' + result + '<span class="result-unit">mm</span></span>';
        console.log('[Spine Calculator] Result:', result + 'mm');

        // 結果が表示されたらスクロールして見えるようにする
        resultTag.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
        console.error('[Spine Calculator] Calculation failed:', { page, paperThickness, coverThickness });
        return false;
    }
}

// DOMContentLoaded時に初期化（他のページに影響を与えない）
document.addEventListener('DOMContentLoaded', function() {
    // .spine-calculator 内のフォームが存在する場合のみ実行
    var container = document.querySelector('.spine-calculator');
    var resultTag = document.getElementById('sw_calculation_result');
    if (container && resultTag) {
        console.log('[Spine Calculator] Initialized successfully');
        console.log('[Spine Calculator] Cover select options:', container.querySelector('#cover_select')?.options?.length || 0);
        console.log('[Spine Calculator] Paper select options:', container.querySelector('#paper_select')?.options?.length || 0);
    }
});

